import { Component, OnInit,Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { ItemService } from 'app/shared/services/item.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { GuestPurchaseService} from 'app/shared/services/guest-purchase.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith } from 'rxjs/operators';
import { Observable} from 'rxjs';
import { Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'ngx-guest-purchase',
  templateUrl: './guest-purchase.component.html',
  styleUrls: ['./guest-purchase.component.scss']
})
export class GuestPurchaseComponent implements OnInit {

  form: FormGroup;
  showProcessingIndicator = false;
  isEmpIdReadOnly : boolean= true;
  showBtn : boolean= true;
  isReadOnly : boolean= true;

  guestPurchase:any;

  itemList : any[];
  filteredOptions:  Observable<any[]>;

  filteredCustomerList: Observable<any[]>;
  customerList : any[];


  validationMessages = {
    'guestId': { 'required': 'This field is required' },
    'guestName': { 'required': 'This field is required' },
    'purchaseDate': { 'required': 'This field is required' },
    'itemCode': { 'required': 'This field is required' },
    'description': { 'required': 'This field is required' },
    'unitPrice': { 'required': 'This field is required' },
    'qty': { 'required': 'This field is required' },
    'amount': { 'required': 'This field is required' },
  };

  formErrors = {
    'guestId': "",
    'guestName': "",
    'purchaseDate': "",
    'itemCode': "",
    'description': "",
    'unitPrice': "",
    'qty': "",
    'amount': "",
  };



  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<GuestPurchaseComponent>,
    private fb: FormBuilder,
    private itemService: ItemService,
    private customerService : CustomerService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private authService: AuthService,
    private router : Router,
    private guestPurchaseService : GuestPurchaseService,
    
   
  ) {   

    this.guestPurchase =data;
  }

  ngOnInit(): void {

    this.getCustomerList();
    this.getItemList();
    this.initFormFields();
    this.getTableRowData(this.guestPurchase);

    this.autoComplete();
    this.autoCompleteCustomer();

    this.form.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.form);
      });


  } // end Oninit

 
  autoComplete(){
    this.filteredOptions =this.form.get('itemCode').valueChanges
    .pipe(
      startWith(''),
        map(value => this._filter(value))
    );

  }

  autoCompleteCustomer(){
      this.filteredCustomerList = this.form.get('guestName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  private _filter(itemCode: string): any[] {
    if(itemCode){
    const filterValue = itemCode.toLowerCase();
    return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  
  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.GuestName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  getItemData(){
    var filteredData;
    var value  = this.form.get('itemCode').value;
    if(this.showBtn){
    if(value){
    filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
    if(filteredData.length ===1){
      this.form.patchValue({ 
        description : filteredData[0].Description,
        salesType :  filteredData[0].Category,
        unitCost : filteredData[0].UnitCost,
        unitPrice:  filteredData[0].UnitPrice,
        qty :'1.00', 
        amount : filteredData[0].UnitPrice,
      });    
    }else{
      this.form.patchValue({ 
        description : '',
        salesType : '',
        unitCost : '',
        unitPrice:  '',
        qty: '',
        amount : '',
      });     

    }
  }
}
}



getCustomerDetails(){      
  var filteredData;
  var cusName = this.form.value.guestName;
  if(cusName){
  filteredData = this.customerList.filter(data =>data.GuestName.toLowerCase()===cusName.toLowerCase());
  if(filteredData.length ===1){
     this.form.patchValue({
       guestId : filteredData[0].GuestId,
     });

   }else{
    this.form.patchValue({
       guestId : null,
    });
   }
  }
}
     

  
getItemList(){
  this.itemService.getAll()
     .subscribe(
        (data) => {
                  this.itemList = data;
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
 }

  getCustomerList(){
  this.customerService.getAll()
   .subscribe(
      (data) => {
                this.customerList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }




  initFormFields(){
    this.form = this.fb.group({
      id: [null],
      guestId: ['',Validators.required],
      guestName: ['', Validators.required],
      purchaseDate: ['', Validators.required],
      itemCode: ['', Validators.required],
      description: ['', Validators.required],
      salesType: [''],
      unitCost: [''],
      unitPrice: ['', Validators.required],
      qty: ['', Validators.required],
      amount: ['', Validators.required],

    });

  }



 newButtonClick(): void {
    this.isReadOnly = false;
    this.enableForm();
    this.form.reset();
    this.resetValiationErrors();

   }

   onClose(){
    this.form.reset();
    this.dialogRef.close();
   }

   isNumeric(value){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }

   calEachItemAmount(){
  
      var unitPrice : number;
      var qty : number;
      var amount : number=0;
      
      var itemCode  = this.form.get('itemCode').value;
      if(this.showBtn){
      if(itemCode){
          unitPrice = this.isNumeric(this.form.get('unitPrice').value) ? parseFloat(this.form.get('unitPrice').value) :null;
          qty = this.isNumeric(this.form.get('qty').value) ?  parseFloat(this.form.get('qty').value) : null;
          amount = (this.isNumeric(unitPrice) && this.isNumeric(qty)) ? parseFloat((unitPrice * qty).toFixed(2)) : null;

          this.form.patchValue({unitPrice : unitPrice});
          this.form.patchValue({qty : qty});
          this.form.patchValue({amount : amount});

      }
   }


  }



  saveButtonClick(): void {
    var data: any;
    
    this.logValidationErrors(this.form, true);
   const formData =this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {
        this.showProcessingIndicator = true;
        this.guestPurchaseService.create(formData)
          .subscribe(
            (res) => {
              data = res;
                this.toastr.success('Record created successfully', 'Success');               
                this.showProcessingIndicator = false;   
                this.onClose();               
                
            },
            (err) => {
              this.toastr.error('Failed to create record', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )


    }
    else {
      this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
      this.showProcessingIndicator = false;

    }


  }


  enableForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
     // console.log(key)
    });
  }

  disableForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].disable();
     // console.log(key)
    });
  }

  resetValiationErrors(){
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).setErrors(null) ;
    });
  }

  logValidationErrors(group: FormGroup = this.form, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {

    var value = this.form.value.guestId;
    if(!value){
      this.form.patchValue({ guestId :  null,guestName :  null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
    }
    return true;
  }

  mapFormValuesToModel() {
    let formData ={
      ...this.form.value,
      purchaseDate: this.form.value.purchaseDate ? moment(this.form.value.purchaseDate).format("YYYY-MM-DD"): null,
      status: 'Not Invoiced',
      createdBy : this.authService.getUserLoggedIn(),
    }
    return formData;

  }



  getTableRowData(data) {
    if (data) {
      this.form.patchValue({
        id: data.Id,
        guestId: data.GuestId,
        guestName: data.GuestName,
        purchaseDate: moment(data.PurchaseDate).format("YYYY-MM-DD"),
        itemCode: data.ItemCode,
        description: data.Description,
        unitPrice :data.UnitPrice,
        qty: data.Qty,
        amount: data.Amount,
  
      });
      this.isReadOnly = true;
      this.showBtn = false
    }else{
      this.newButtonClick();
    }


  }





}// end class
